import 'es6-symbol/implement'; //ponyfills Symbol for IE. Observe uses Symbol
import Observe from 'observe';
import { downloads } from '../constants';
import root from 'window-or-global';

if (!root._epicGamesNavObserverCallbacks) {
    root._epicGamesNavObserverCallbacks = [];
}


/**
 * Set the defaults for the config. If testing make sure to restore the defaults to good production settings.
 *  It is probably best to not use this for testing.
 *
 * Test config has moved!! Please use /scripts/components/test/testConfig.js instead!
 */
const defaultConfig = {
    debug: false,

    //theme name must match with a key in constants/properties
    epicPropertyName: 'epic_games',

    //whether the user is logged in or not. controls the signon dropdown
    isLoggedIn: false,

    //sets the main links in the navigation
    links: [],

    //hides the locale dropdown
    hideLocale: true,

    //hides the search
    hideSearch: true,

    //hides the sign in and username dropdown
    hideSignIn: true,

    hideCallToAction: true,

    hideShieldDownload: false,

    //customize the call to action
    callToAction: {},

    //currently selected locale. should match a lang in the localeOptions
    locale: 'en-US',

    //user's gamertag if logged in
    displayName: 'Account',

    //items in the locale dropdown
    localeOptions: [],


    //controls the anchor tag of the property logo
    logoLink: {},

    //account related links
    accountLinks: {

        //shows dropdown for sign in options if array length > 1
        signInLinks: [],

        //sign out link
        signOutLink: {},

        //links which will go in the logged in dropdown menu
        dropdownLinks: []
    },

    downloadLink: {
        title: 'Get Epic Games',
        href: '#'
    },

    pcDownloadUrl: downloads.pcDownloadUrl,
    macDownloadUrl: downloads.macDownloadUrl,

    // EU cookie
    country: 'US',
    isEu: false,
    policyUrl: 'https://www.epicgames.com/privacypolicy',
    euCookieStrings: {
        cookieString: 'We use cookies to ensure the best experience on all Epic Games websites. To learn more, please see our {0}.',
        policyString: 'privacy policy',
        closeString: 'Close'
    }
};

//Loop over the epicGamesNav object and plug in any missing keys from the defaultConfig
if (!root._epicGamesNav) {
    root._epicGamesNav = defaultConfig;
} else {
    const missingAssumeFalsey = ['hideLocale', 'hideSearch', 'hideSignIn', 'hideCallToAction'];
    for (const key in defaultConfig) {
        if (key && typeof key === 'string') {
            if (!root._epicGamesNav.hasOwnProperty(key) && missingAssumeFalsey.indexOf(key) === -1) {
                root._epicGamesNav[key] = defaultConfig[key];
            }
        }
    }
}

root._epicGamesNavObserver = Observe(root._epicGamesNav);
root._epicGamesNavObserver.on('change', (change) => {
    if (root._epicGamesNavObserverCallbacks && root._epicGamesNavObserverCallbacks.length) {
        for (let i = 0; i < root._epicGamesNavObserverCallbacks.length; i++) {
            const callback = root._epicGamesNavObserverCallbacks[i];
            if (callback && typeof callback === 'function') {
                callback(change);
            }
        }
    }
});

root._epicGamesNavObserverCreated = true;

const addObserverCallback = (fn) => {
    if (typeof fn === 'function') {
        root._epicGamesNavObserverCallbacks.push(fn);
    }
};

export default addObserverCallback;



// WEBPACK FOOTER //
// ./app/scripts/utils/epicGamesNavObserver.js